<nav
  class="navbar navbar-expand-xl fixed-top py-1 py-lg-3"
>
  <div class="container-fluid navbar-custom">
    <div class="c7-brandbar">
      <a class="navbar-brand text-primary fw-bold fs-1 update-logo-button" href="javascript:void(0)">
        <img src="../../../assets/logo-blue.png" alt="CULTURA" />
      </a>
    </div>
    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mx-auto mb-2 mb-lg-0">
        <li class="" *ngIf="isManager || isAdmin">
          <a
            routerLinkActive="active"
            [routerLink]="isManager ? ['/invitations'] : ['/admin']"
            ><i class="bi" [ngClass]="isManager ? 'bi-send' : 'bi-grid'"></i>{{ (isManager ? "menu.invitations" : "uiPack.navigation.companies") | translate }}</a
          >
        </li>

         <li *ngIf="showQuestionaryMenu">
          <a routerLinkActive="active" [routerLink]="['/questionary']"><i class="bi bi-file-earmark-text"></i>{{
            "menu.questionary" | translate
          }}</a>
        </li>
        <li *ngIf="isManager || isAdmin ">
          <a routerLinkActive="active" [routerLink]="isManager ? ['/progress'] : ['/users']"><i class="bi bi-people"></i>{{
            "menu.users" | translate
          }}</a>
        </li>
        <li *ngIf="isAdmin">
          <a routerLinkActive="active" [routerLink]="['/knowledge-manager']">
            <i class="bi bi-book"></i> {{ "batchReport.menuKnowledgeBase" | translate }}
          </a>
        </li>
        <li *ngIf="isAdmin">
          <a routerLinkActive="active" [routerLink]="['/data-requests']">
            <i class="bi bi-person-x"></i> {{ "dataRequests.menu" | translate }}
          </a>
        </li>
        <li *ngIf="isAdmin">
          <a routerLinkActive="active" [routerLink]="['/cultura-reports/batch']">
            <i class="bi bi-file-earmark-pdf"></i> {{ "batchReport.menuBatchReports" | translate }}
          </a>
        </li>
        <li
          *ngIf="
            isManager || isAdmin || (isEmployee && questionary === 'DONE') || (isApplicant && questionary === 'DONE') || (isTrainee && questionary === 'DONE')
          "
        >
          <a routerLinkActive="active" [routerLink]="['/report']"><i class="bi bi-bar-chart"></i>{{
            "menu.report" | translate
          }}</a>
        </li>
      </ul>
      <div class="d-flex gap-3">
        <div class="c7-company-chip" *ngIf="logoSrc || user?.company_name" [attr.title]="user?.company_name">
          <img *ngIf="logoSrc" [src]="logoSrc" [alt]="user?.company_name || 'Company'" (error)="logoSrc = null" />
          <span class="c7-company-chip__name" *ngIf="user?.company_name">{{ user.company_name }}</span>
        </div>
        
        <div class="btn-group avatar-header-block cursor-pointer">
          <a
           [class.on-profile]="onProfile"
            id="dropdownMenuClickableInside"
            data-bs-toggle="dropdown"
            data-bs-auto-close="inside-outside"
            aria-expanded="false"
          >
          <img [src]="profileImagePreview || '../../../assets/avatar-icon.png'" alt="Profile">
        </a>
          <ul
            class="dropdown-menu"
            aria-labelledby="dropdownMenuClickableInside"
          >
            <li *ngIf="isManager || isAdmin || isEmployee || isApplicant || isTrainee">
              <a class="dropdown-item" routerLinkActive="active" [routerLink]="['/profile']">
                <i class="bi bi-person"></i> {{ "menu.profile" | translate }}
              </a>
            </li>
            <li  *ngIf="isManager">
              <a

                class="dropdown-item"
                href="javascript:void(0)"
               
                (click)="companyDetail()"
                ><i class="bi bi-building"></i> {{
            "menu.companyDetails" | translate
          }}
              </a>
            </li>
            <li *ngIf="isManager || isAdmin">
              <a
                class="dropdown-item"
                href="javascript:void(0)"
                data-bs-toggle="modal" data-bs-target="#remainderModal"
                >  <i class="bi bi-bell"></i> {{ "uiPack.navigation.reminderSettings" | translate }}</a
              >
            </li>
            <li>
              <a class="dropdown-item" [routerLink]="['/privacy-settings']">
                <i class="bi bi-shield-check"></i> {{ "consentsPage.menu" | translate }}
              </a>
            </li>
            <li>
              <a
                class="dropdown-item"
                href="javascript:void(0)"
                data-bs-toggle="modal" data-bs-target="#userModal"
                > <i class="bi bi-box-arrow-right"></i> {{
                  "menu.logouts" | translate
                }}</a
              >
            </li>
            
          </ul>
        </div>
      
    
        
        <div class="position-relative language-btn-block">
          <button
            class="language-btn"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <img
              [src]="getLanguageFlag(selectedLanguage)"
              class="selected-flag"
            />
            <span>
              {{ getLanguageName(selectedLanguage) }}
            </span>
          </button>
          <ul class="dropdown-menu">
            <li *ngFor="let language of supportedLanguages">
              <a
                class="dropdown-item"
                href="javascript:void(0)"
                (click)="changeLanguage(language.code)"
              >
                <img [src]="language.flag" />
                <span>
                  {{ language.name }}
                </span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</nav>




<!-- Reminder Modal -->
<div
  class="modal fade c7-dialog"
  id="remainderModal"
  tabindex="-1"
  aria-labelledby="ModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-6" id="ModalLabel">
          <strong>Send Reminder</strong>
        </h1>
        <button
          type="button"
          class="btn-close-modal"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          <img src="../../../assets/close-icon-white.svg" />
        </button>
      </div>
      <div class="modal-body">
            <div class="">
              <strong>Send a reminder to complete the quiz:</strong>
              <select class="form-select mt-2" [(ngModel)]="reminderTime">
                <option value="1">1 Hour</option>
                <option value="24">1 Day</option>
                <option value="168">7 Days</option>
              </select>
            </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-secondary px-4 d-flex align-items-center gap-2 border-0"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          {{ "form.Cancel" | translate }}
        </button>
        <button
          type="button"
          class="btn btn-primary px-4 d-flex align-items-center gap-2 border-0"
          (click)="sendReminder(reminderTime)"
        >
          Send
        </button>
      </div>
    </div>
  </div>
</div>


<!-- Modal account-->
<div
  class="modal fade c7-dialog"
  id="userModal"
  tabindex="-1"
  aria-labelledby="ModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-6" id="ModalLabel">
          <strong>{{ "report.user" | translate }}</strong>
        </h1>
        <button
          type="button"
          class="btn-close-modal"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          <img src="../../../assets/close-icon-white.svg" />
        </button>
      </div>
      <div class="modal-body">
        <div class="">
          <div class="">
            <div class="">
              <strong>{{ "menu.logout" | translate }}</strong>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-secondary px-4 d-flex align-items-center gap-2 border-0"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
        {{ "form.Cancel" | translate }}
        </button>
        <button
          type="button"
          class="btn btn-primary px-4 d-flex align-items-center gap-2 border-0"
          (click)="logOut()"
        >
        {{ "form.ok" | translate }}

        </button>
      </div>
    </div>
  </div>
</div>
